const { Modal, Offcanvas } = globalThis.unlk;
import { getProgress, saveProgress } from '../utilities/_get-progress';
import { completeTopicAndSync } from './archive-lessons';
import { sendTrack } from '../utilities/track';

document.addEventListener('DOMContentLoaded', () => {
  applyTopicPillStates();
  handleTopicVisit();
  initSaveForms();
});

function applyTopicPillStates() {
  const progress = getProgress();
  const completed = new Set((progress.completed_topics || []).map(Number));
  const inProgress = new Set((progress.in_progress_topics || []).map(Number));

  for (const li of document.querySelectorAll('.topic-nav-item[data-topic-id]')) {
    const id = Number(li.dataset.topicId);
    li.classList.toggle('is-complete', completed.has(id));
    li.classList.toggle('is-active', !completed.has(id) && inProgress.has(id));
  }

  const completedCount = document.querySelector('.edu-lessons-complete');
  if (completedCount) {
    const lessonTopicIds = (globalThis.unlkEduLesson?.topics ?? []).map((t) => Number(t.id));
    completedCount.textContent = lessonTopicIds.filter((id) => completed.has(id)).length;
  }
}

function handleTopicVisit() {
  const lessonData = globalThis.unlkEduLesson ?? {};
  const topics = lessonData.topics ?? [];
  if (topics.length === 0) return;

  const currentUrl = globalThis.location.href.split('?')[0].replace(/\/$/, '');
  const match = topics.find((t) => (t.url ?? '').replace(/\/$/, '').split('?')[0] === currentUrl);
  if (!match) return;

  const topicId = Number(match.id);
  if (!topicId) return;

  const progress = getProgress();

  const hasQuiz = Boolean(document.querySelector('.education-quiz'));

  if (hasQuiz) {
    const inProgress = progress.in_progress_topics || [];
    if (!inProgress.includes(topicId)) {
      // eslint-disable-next-line camelcase
      saveProgress({ ...progress, in_progress_topics: [...inProgress, topicId] });
    }
  } else {
    const topicUrl = match.url ?? globalThis.location.href;
    const lessonTopicIds = topics.map((t) => Number(t.id));
    const lessonId = Number(lessonData.lessonId ?? 0);
    completeTopicAndSync(topicId, topicUrl, lessonTopicIds, lessonId);
    applyTopicPillStates();
  }
}

function initSaveForms() {
  // Save form (modal)
  document.getElementById('edu-save-form')?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const emailInput = event.target.querySelector('[name="email"]');
    const email = emailInput?.value?.trim() ?? '';
    const result = await handleSaveSubmit(email);
    if (!result.success) {
      const errorEl = event.target.querySelector('.edu-save-error');
      if (errorEl) errorEl.textContent = result.error;
    }
  });

  // Save form (offcanvas bar)
  document.getElementById('edu-save-bar-form')?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const emailInput = event.target.querySelector('[name="email"]');
    emailInput?.classList.remove('is-invalid');

    const email = emailInput?.value?.trim() ?? '';
    const result = await handleSaveSubmit(email);

    if (!result.success && emailInput) {
      emailInput.classList.add('is-invalid');
      const feedbackText = event.target.querySelector('.invalid-feedback span');
      if (feedbackText) feedbackText.textContent = result.error;
    }
  });
}

function dismissSavePrompt() {
  const saveEl = document.getElementById('edu-save-modal');
  if (saveEl) Modal.getOrCreateInstance(saveEl).hide();
  const saveBarEl = document.getElementById('edu-save-bar');
  if (saveBarEl) Offcanvas.getOrCreateInstance(saveBarEl).hide();
}

async function handleSaveSubmit(email) {
  if (!isValidEmail(email)) {
    return { success: false, error: 'Please enter a valid email address.' };
  }

  try {
    const progress = getProgress();
    await saveToServer(email, progress);
    globalThis.unlk?.setSavedEmail?.(email);
    dismissSavePrompt();

    sendTrack('Progress Saved', {
      email,
      // eslint-disable-next-line camelcase
      lessons_complete: progress.completed_lessons.length,
      // eslint-disable-next-line camelcase
      topics_complete: progress.completed_topics.length,
      // eslint-disable-next-line camelcase
      last_topic_name: globalThis.unlkEduLesson?.topicTitle ?? '',
      // eslint-disable-next-line camelcase
      last_lesson_name: globalThis.unlkEduLesson?.lessonTitle ?? '',
      // eslint-disable-next-line camelcase
      last_topic_url: progress.last_topic_url
    });

    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

async function saveToServer(email, progress) {
  const REST_BASE = globalThis.unlkEdu?.restUrl ?? '/wp-json/unlk/v1';
  const NONCE = globalThis.unlkEdu?.nonce ?? '';

  const response = await fetch(`${REST_BASE}/education/save`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': NONCE
    },
    body: JSON.stringify({ email, ...progress })
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || 'Save failed');
  }

  return response.json();
}

function isValidEmail(email) {
  return Boolean(email) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
